import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	relativeDate: {
		id: 'development.common.components.relative-date.text',
		defaultMessage: '{relativeDate} ago',
		description: 'Shows the relative time of the last update compared to the present',
	},
});
